/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, Input, OnChanges } from '@angular/core';
import { iconEmptyStar } from 'core/icons/lib/icon-empty-star';
import { iconStar } from 'core/icons/lib/icon-start';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent implements OnChanges {
  starIcon = iconStar;
  emptyStarIcon = iconEmptyStar;

  @Input() rating = 5;

  stars = Array(5).fill(false);

  ngOnChanges(): void {
    this.stars = this.stars.map((_, i) => this.rating > i);
  }
}
